import {sortConstants} from '../../../util/uiconstants';
import getDocumentsCount from './getDocumentsCount';

export const mapInstruction = (
	{
		instructionId,
		instructionName,
		instructionDescription,
		dueDate,
		isCustom,
		knowledgeInstructionName,
		knowledgeInstructionDescription,
		knowledgeModifyDate,
		knowledgeDisplayOrder,
		scopes,
		components,
		documents,
		auditPhaseId
	},
	sectionId
) => {
	let formattedDueDate = dueDate;
	if (dueDate !== null && !dueDate.includes('Z')) formattedDueDate = `${dueDate}Z`;
	return {
		id: instructionId,
		instructionName,
		sectionId,
		instructionDescription,
		dueDate: formattedDueDate,
		isCustom,
		knowledgeInstructionName,
		knowledgeInstructionDescription,
		knowledgeModifyDate,
		knowledgeDisplayOrder: knowledgeDisplayOrder || sortConstants.knowledgeDisplayOrder, // This way we can order nulls last,
		scopes,
		components,
		documents,
		documentsCount: getDocumentsCount(documents),
		auditPhaseId
	};
};

const mapSections = ({sectionId, sectionName, isCustom, knowledgeInstructionSectionId, instructions}) => ({
	id: sectionId,
	sectionName,
	isCustom,
	knowledgeInstructionSectionId,
	instructions: instructions?.map((section) => mapInstruction(section, sectionId))
});

export default (sections) => sections?.map(mapSections);
